module.exports = __webpack_public_path__ + "static/img/49.d839a53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene/49.jpg
// module id = ZiAD
// module chunks = 3